import React from "react";
import "../css/course.css";
import { ReactComponent as Likes } from "../assets/icons/main-sect1/like-tag.svg";
import { ReactComponent as People } from "../assets/icons/main-sect1/people.svg";
import TeacherPic from "../assets/images/sect1-profile-picture.png";
const Course = ({ id, courseImage }) => {
  return (
    <div id={id} className="lp-sect-1-course">
      <img src={courseImage} alt="subject banner" />
      <h4>Understanding matrixes and determinants</h4>
      <div>
        <span className="ratings">
          <Likes />
          <span>4.8 (233)</span>
        </span>
        <span>
          <People />
          <span>
            <span>35,999 </span>
            <span> students</span>
          </span>
        </span>
      </div>
      <hr />
      <div className="other-details">
        <span className="course-author">
          <img src={TeacherPic} alt="the teacher of this course" />
          <span>John Kennedy</span>
        </span>
        <span>N2330</span>
      </div>
    </div>
  );
};

export default Course;
